import { NavLink } from 'react-router-dom';
import {
  COMMERCIAL_VESSEL_VOYAGE_REPORTS,
  MANAGE_USERS,
  PLEASURE_CRAFT_VOYAGE_REPORTS
} from '../constants/AppConstants';
import {
  MANAGE_USERS_URL,
  REPORTED_VOYAGES_DASHBOARD_URL,
  SPCR_DASHBOARD_URL
} from '../constants/AppUrlConstants';
import Auth from '../utils/Auth';

/**
 * Although it seems redundant, we add the extra check that user has type of internal
 * and hide all nav if they don't
 * This is just added protection that if somehow an external user successfully logs into this app
 * they still can't view what's here.
 * We have added protection on protected routes for the same reason.
 */

const Nav = () => {
  const adminView = Auth.retrieveUserAccess()?.admin;
  const legacyUser = Auth.retrieveUserAccess()?.legacyUser;
  const stdUser = Auth.retrieveUserAccess()?.stdUser;
  const allView = legacyUser || stdUser || adminView;
  const stdAndAdminView = stdUser || adminView;
  return (
    <nav id="navigation" className="hods-header__navigation" role="navigation">
      <ul aria-label="Top Level Navigation" className="hods-header__navigation-list">
        {allView && (
        <li className="hods-header__navigation-list__item">
          <NavLink
            className="hods-header__navigation-list__link"
            to={REPORTED_VOYAGES_DASHBOARD_URL}
          >
            {COMMERCIAL_VESSEL_VOYAGE_REPORTS}
          </NavLink>
        </li>
        )}
        {stdAndAdminView && (
          <li className="hods-header__navigation-list__item">
            <NavLink
              className="hods-header__navigation-list__link"
              to={SPCR_DASHBOARD_URL}
            >
              {PLEASURE_CRAFT_VOYAGE_REPORTS}
            </NavLink>
          </li>
        )}
        {adminView && (
        <li className="hods-header__navigation-list__item">
          <NavLink
            className="hods-header__navigation-list__link"
            to={MANAGE_USERS_URL}
          >
            {MANAGE_USERS}
          </NavLink>
        </li>
        )}
      </ul>
    </nav>
  );
};

export default Nav;
